<template>
   <div class="dashboard-page">
      <div class="mt-3 pt-3">
			<nav class="mb-5" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='white'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
            <ol class="breadcrumb" style="font-size:24px; line-height: 24px; font-weight:900;">
               <li class="breadcrumb-item" style="color:#435666;" aria-current="page">Dashboard</li>
            </ol>
         </nav>
		</div>

       <div class="content-wrapper mt-4">

         <div class="dashboard-widgets-container">
            <bdm-manager />
            <client-questions />
         </div>

      </div>

   </div>
</template>

<script>
import BdmManager from '@/components/Dashboard/BdmManager.vue';
import ClientQuestions from '@/components/Dashboard/ClientQuestions.vue';

export default {
  name: 'DashboardPage',
  components: {
    BdmManager,
    ClientQuestions,
  },
};
</script>

<style scoped>
.content-wrapper {
  position: relative;
  width: 100%;
  min-height: 80vh;
}

.dashboard-widgets-container {
    display: flex;
    flex-wrap: wrap; 
    gap: 1.5rem; 
    align-items: flex-start; /* Aligns items to the top of the container */
    justify-content: flex-start; /* Aligns items to the left */
}
</style>